import { PlatformIntegration } from '@/platform/platform-integration';
import { ReflectorIntegration } from '@/infrastructure/reflector/reflector-integration';
import { ReflectorResponse } from '@/infrastructure/reflector/reflector-response';
import { arrayFirstItemOrNull } from '@/platform/core/array-extensions';

import { ReflectorBody } from '@/infrastructure/reflector/reflector-body';
import { Body } from './body';

class BodyPresenter extends ReflectorIntegration {
	public async retrieve(id: string): Promise<Body | null> {
		const authorization = await PlatformIntegration.instance.authorizer.authorizeBodyQuery();

		const response = await this.send<ReflectorBody>(`data/bodies/any/details/`, `ids-${id}`, authorization);
		const bodies = this.reconstitute(response);

		return arrayFirstItemOrNull(bodies);
	}

	public async search(query: string | undefined): Promise<readonly Body[]> {
		if (query === undefined || query.trim().length === 0) {
			return [];
		}

		const authorization = await PlatformIntegration.instance.authorizer.authorizeBodyQuery();

		const response = await this.send<ReflectorBody>(
			`data/bodies/any/details/`,
			this.determineSearchQuery(query),
			authorization
		);
		const bodies = this.reconstitute(response);

		return bodies;
	}

	private reconstitute(response: ReflectorResponse<ReflectorBody>): readonly Body[] {
		return Array.isArray(response) ? [] : Object.values(response).map((source) => new Body(source.id, source.name));
	}
}

export default new BodyPresenter();
